<template>
  <div class="star_box">
    <!-- 星星 -->
    <div class="rate_star" :class="{'good': isGood}">
      <i
        class="rate_star_icon"
        v-for="(icon, iconIndex) in scoreInfo"
        :key="'icon' + iconIndex"
        :class="iconIndex + 1 > score/100 ? 'icon-outline_star_rating' : 'icon-filled_star cur'"
        @click="handleSelect(icon)"
      ></i>
    </div>
    <!-- 文案 -->
    <p v-if="seeDesc" class="select_msg" :class="{'good': isGood}">{{seeDesc}}</p>
    <p v-show="selectMsg" class="select_msg" :class="{'good': isGood}">{{selectMsg}}</p>
  </div>
</template>

<script>
export default {
  name: 'EvaluateStar',
  props: {
    // 列表
    scoreInfo: {
      type: Array,
      default: () => [],
    },
    // 初始评分
    starScore: {
      type: Number,
      default: 0,
    },
    // 是否是编辑
    edit: {
      type: Boolean,
      default: true,
    },
    seeDesc: {
      type: String,
    },
    compType: {
      type: String,
      validator: function (value) {
        return ['onlyShow'].indexOf(value) !== -1
      }
    }
  },
  computed: {
    isGood() {
      return this.score >= 500
    }
  },
  watch: {
    starScore: {
      handler(val) {
        this.score = val;

        this.scoreInfo.forEach(item => {
          const { desc, score} = item;
          if (score === val) {
            this.selectMsg = desc
          }
        });
      },
      immediate: true
    }
  },
  data() {
    return {
      score: 0,
      selectMsg: '',
    }
  },
  methods: {
    handleSelect(item) {
      if(!this.edit) {
        return
      }
      if (this.compType !== 'onlyShow') {
        this.score = item.score
        this.selectMsg = item.desc
      }
      // 抛出事件
      this.$emit('on-change-star', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.star_box {
  text-align: center;
}
.rate_star {
  margin-bottom: 12px;
  font-size: 32px;
  color: #ccc;
}
.rate_star.good .rate_star_icon {
  @include font-color();
}
.rate_star_icon {
  display: inline-block;
  margin-right: 20px;
  cursor: pointer;
}
.cur {
  color: #666;
}
.rate_star_icon:last-child {
  margin-right: 0;
}
.select_msg {
  font-family: 'Aspira Medium';
  font-weight: 500;
  font-size: 16px;
  color: #666;
  &.good {
    @include font-color();
  }
}

// 移动端适配
@media screen and (max-width: 768px) {
  .rate_star {
    font-size: rem(60);
  }
  .select_msg {
    font-size: rem(32);
  }
}
</style>
